var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.591 4.40625C24.2023 3.00926 22.5507 1.9007 20.7314 1.14447C18.9121 0.38824 16.961 -0.000721498 14.9906 1.0047e-06C6.69794 1.0047e-06 0 6.7125 0 15C0 23.2875 6.69794 30 14.9906 30C21.9887 30 27.8236 25.2188 29.4934 18.75H25.591C24.8181 20.9428 23.3834 22.842 21.4847 24.1853C19.586 25.5287 17.317 26.2501 14.9906 26.25C8.78049 26.25 3.73358 21.2063 3.73358 15C3.73358 8.79375 8.78049 3.75 14.9906 3.75C18.1051 3.75 20.8818 5.04375 22.9081 7.0875L16.8668 13.125H30V1.0047e-06L25.591 4.40625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.6dfd79a807ad2354a2ac972b2a47c371.svg";
export { ForwardRef as ReactComponent };